<template>
  <div>
    <script :id="id" type="text/plain"></script>
  </div>
</template>
<script>
import '../../static/ueditor/ueditor.config.js'
import '../../static/ueditor/ueditor.all.min.js'
import '../../static/ueditor/lang/zh-cn/zh-cn.js'

export default {
  name: 'UE',
  data () {
    return {
      editor: null,
    }
  },
  props: {
    value: { type: String },
    config: {
      type: Object
    }
    , id: {
      type: String
    }
  },
  mounted () {
    const _this = this
    this.$nextTick(() => {
      this.editor = UE.getEditor(this.id, this.config);
      this.editor.addListener('ready', function () {
        _this.editor.setContent(_this.value)
      })
    });
  },
  methods: {
    getUEContent () {
      return this.editor.getContent()
    },
    setContent (content) {
      return this.editor.setContent(content)
    }
  },
  destroyed () {
    this.editor.destroy()
  }
}
</script>
<style>
.edui-default {
  line-height: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UEditor.vue